import React from "react";
import DateBlock from "./DateBlock.mjs";
import Tag from "./Tag.mjs";

export default function TournamentCard({ ...data }) {
  const startDateTime = new Date(data.start_date_time);
  const startTimeString = startDateTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true, });

  return (
    <div className="bg-white rounded shadow p-3">
      <div className="vstack gap-3">
        <h4 className="text-dark-subtle mb-0">{data.name}</h4>
        <div className="row">
          <div className="col-sm-5 col-xl-4">
            <DateBlock startDateTime={startDateTime} />
          </div>
          <div className="col-sm-7 col-xl-8">
            <p className="my-4 mt-md-0 subhead-2 text-primary">{data.limit_type} {data.game_type}</p>
            <div className="d-flex gap-2 flex-wrap">
              <Tag icon='schedule' text={startTimeString} />
              <Tag icon='attach_money' text={`$${(data.buy_in ?? 0).toLocaleString()}`} />
              <Tag icon='emoji_events' text={`$${(data.prize_pool ?? 0).toLocaleString()}`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
